module.exports = __webpack_public_path__ + "img/second-banner-somos-zama-01.b62bff42.png";